export default __webpack_public_path__ + "static/media/Photo 6 - BR - Store banne.89601572.png";